/**
 * Created by Yoyo Fang on 05/24/2019
 * Description:
 *
 * ------ maintenance history ------
 * 08/19/2019 add track by function for ng if
 */
import { Component, OnInit, ViewChild, OnDestroy, ElementRef, Input } from '@angular/core';
import { EventManager } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SimpleSearchService, SimpleSearchResult, SimpleSearchResultType } from '../../tamalelibs/services/simple-search.service';
import { AUTO_SEARCH_INTERVAL } from '../../tamalelibs/constants/business.constants';
import { EntityType } from '../../tamalelibs/models/entity-type.model';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { BriefConfig } from '../../widgets/widgets.model';
import { SlideSheetTempService } from '../../services/slide-sheet-temp.service';

@Component({
    selector: 'tam-simple-search',
    templateUrl: './simple-search.component.html',
    styleUrls: ['./simple-search.component.scss']
})
export class SimpleSearchComponent implements OnInit, OnDestroy {
    @ViewChild('searchBar', { static: false }) private _searchBar: ElementRef;
    @ViewChild('searchPopup', { static: false }) private _searchPopup: any;
    @Input() config: BriefConfig;
    public dropdownList: any[] = [];
    public searchTerm = '';
    public searching = false;
    private searchTask: NodeJS.Timer = null;
    public showPopup = false;
    public minimumIndex = 0;
    public selectedIndex: number = this.minimumIndex;
    private _subscriptions: Subscription[] = [];
    private _mousedownHandler: Function;
    private _keywordParamName = 'keyword';
    // const private _maximumRecords = 10;
    constructor(
        private _simpleSearchService: SimpleSearchService,
        private _eventManager: EventManager,
        private _router: Router,
        private _routerInfo: ActivatedRoute,
        private _store: Store<any>,
        private _tempSlideSheet: SlideSheetTempService,
    ) {
    }

    ngOnInit() {
        this.searchTerm = this._routerInfo.snapshot.params[this._keywordParamName];
        this._subscriptions.push(
            this._simpleSearchService.subscribe(this._handleSearchResult()),

            this._routerInfo.params.subscribe((params) => {
                if (params && params[this._keywordParamName]) {
                    this.searchTerm = params[this._keywordParamName];
                }
            }),

            this.config.actionSubject$.subscribe(action => this.focusSearchBar()),
        );
        // clicking popup item should not trigger searchbar blur
        this._mousedownHandler = this._eventManager.addGlobalEventListener('window', 'mousedown', (event) => {
            let parent = event.target ? event.target : event.srcElement;
            while (this._searchPopup && this._searchPopup.container && this._searchPopup.container.nativeElement && parent) {
                if (parent.id === this._searchPopup.container.nativeElement.id) {
                    event.preventDefault();  // prevent default DOM action
                    event.stopPropagation();   // stop bubbling
                    return false;   // return
                } else {
                    parent = parent.parentNode;
                }
            }
        });
    }

    ngOnDestroy() {
        this._subscriptions.forEach(subscription => {
            if (subscription && !subscription.closed) {
                subscription.unsubscribe();
            }
        });
        this._mousedownHandler();
    }

    focusSearchBar() {
        this._searchBar.nativeElement.focus();
    }

    toggleDropdown(open: boolean) {
        // from Damon, for now simple search does not support history search
        // later on when we'd support, remove this check-return code
        if (!this.searchTerm && open) {
            return;
        }

        // will trigger app.component manipulate dom z-index
        // TODO: dispatch and _store should be remove after home page layout gets refactored.
        if (open) {
            this._updateMinimumIndex();
            this._store.dispatch({ type: 'SEARCH_BAR_POPUP_SHOW', payload: null });
        } else {
            this._store.dispatch({ type: 'SEARCH_BAR_POPUP_HIDE', payload: null });
        }
        this.showPopup = open;
        if (open) {
            this.dropdownList = [];
            this.search();
        }
    }
    linkClicked(event: Event) {
        event.preventDefault();
    }
    onItemClicked(item) {
        if (item) {
            this.searchTerm = '';
            this._searchBar.nativeElement.blur();
            this._router.navigateByUrl(item.url);
        } else {
            this.globalSearch();
        }
        this._tempSlideSheet.actionSubject$.next('');
        return;
    }

    onItemHovered(index: number) {
        this.selectedIndex = index;
    }


    onKeydown(event: KeyboardEvent) {
        if (this.showPopup) {
            switch (event.key) {
                case 'ArrowUp':
                    event.preventDefault();
                    event.stopPropagation();
                    if (this.selectedIndex > this.minimumIndex) {
                        this.selectedIndex--;
                    }
                    return;
                case 'ArrowDown':
                    event.preventDefault();
                    event.stopPropagation();
                    if (this.selectedIndex < this.dropdownList.length - 1) {
                        this.selectedIndex++;
                    }
                    return;
                case 'Enter':
                    event.preventDefault();
                    event.stopPropagation();
                    this._tempSlideSheet.actionSubject$.next('');
                    if (this.selectedIndex === -1) {
                        if (this.minimumIndex === -1) {
                            this.globalSearch();
                        }
                    } else if (this.selectedIndex >= 0 && this.selectedIndex < this.dropdownList.length) {
                        this.onItemClicked(this.dropdownList[this.selectedIndex]);
                    } else if (this.searchTerm.length > 2) {
                        this.globalSearch();
                        // for UX immediately responding to user doing global search by keyin and press enter
                    }
                    // navigate by this.searchTerm;
                    return;
            }
        }
    }

    onSearchTermChanged() {
        this._updateMinimumIndex();
        this.search();
    }

    search() {
        // change to 'this.searching = true;' when starts to support history search
        if (this.searchTerm) {
            this.searching = true;
        } else {
            this.toggleDropdown(false);
        }

        if (!this.showPopup) {
            this.toggleDropdown(true);
            return;
        }

        if (this.searchTask) {
            clearTimeout(this.searchTask);
        }
        this.searchTask = setTimeout(() => {
            this._simpleSearchService.search(this.searchTerm);
        }, AUTO_SEARCH_INTERVAL);
    }

    globalSearch() {
        this._searchBar.nativeElement.blur();
        const extras = { queryParams: {} };
        extras.queryParams[this._keywordParamName] = this.searchTerm;
        this.searchTerm = '';
        this._router.navigate(['global_search'], extras);
    }

    private _handleSearchResult() {
        return (result: SimpleSearchResult) => {
            this.selectedIndex = this.minimumIndex;
            if (result.type === SimpleSearchResultType.HISTORY_SEARCH) {
                this.dropdownList = this._prepareDropdownList(result.payload, false);
            } else {
                // only update ui when search result is of current keyword
                this.dropdownList = this._prepareDropdownList(result.payload, true);
            }
            this.searching = result.processing;
        };
    }

    trackByFn(index, item) {
        return item.id;
    }

    private _prepareDropdownList(list, isNewSearch): any[] {
        let result = [];
        if (isNewSearch) {
            result = [].concat(list);
        } else {
            result = [].concat(list, this.dropdownList);
        }
        return result.map((value, index) => this._prepareUrl(value));
    }

    private _prepareUrl(item) {
        if (item && item.type) {
            switch (item.type.id) {
                case EntityType.CONTACT.id:
                    item.url = 'contact/' + item.id;
                    break;
                default:
                    item.url = 'entity/' + item.id;
                    break;

            }
        } else {
            item.url = '#';
        }
        return item;
    }

    private _updateMinimumIndex() {
        const newMinimun = this.searchTerm.length > 2 ? -1 : 0;
        if (newMinimun !== this.minimumIndex) {
            this.minimumIndex = newMinimun;
        }
        if (this.selectedIndex < this.minimumIndex) {
            this.selectedIndex = this.minimumIndex;
        }
    }
}
